import { ResponsiveRadar } from '@nivo/radar';
import { CATEGORY_LABELS } from '@/lib/biomarkers';

interface BiomarkerScorecardProps {
  categoryScores: Record<string, number>;
}

export function BiomarkerScorecard({ categoryScores }: BiomarkerScorecardProps) {
  const data = Object.entries(categoryScores).map(([key, score]) => ({
    category: CATEGORY_LABELS[key] || key,
    score,
  }));

  if (data.length === 0) {
    return (
      <div className="flex h-[400px] items-center justify-center text-gray-400">
        No category scores available
      </div>
    );
  }

  return (
    <div className="h-[400px] w-full">
      <ResponsiveRadar
        data={data}
        keys={['score']}
        indexBy="category"
        maxValue={100}
        margin={{ top: 60, right: 80, bottom: 40, left: 80 }}
        borderColor={{ from: 'color' }}
        gridLabelOffset={24}
        gridLevels={5}
        gridShape="circular"
        dotSize={8}
        dotColor="#c47d2e"
        dotBorderWidth={2}
        dotBorderColor="#fff"
        colors={['#c47d2e']}
        fillOpacity={0.25}
        blendMode="normal"
        animate={true}
        motionConfig="gentle"
        theme={{
          text: {
            fontSize: 12,
            fontFamily: 'Inter, system-ui, sans-serif',
            fill: '#1a2332',
          },
          grid: {
            line: {
              stroke: '#1a2332',
              strokeWidth: 0.5,
              strokeOpacity: 0.15,
            },
          },
          dots: {
            text: {
              fill: '#1a2332',
            },
          },
        }}
        sliceTooltip={({ index, data: sliceData }) => (
          <div className="rounded-lg bg-navy px-3 py-2 text-sm text-white shadow-lg">
            <span className="font-medium">{index}</span>
            <span className="ml-2 text-copper-light">
              {sliceData[0]?.value ?? 0}%
            </span>
          </div>
        )}
      />
    </div>
  );
}
